import { systemType } from '@/constants'
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
function add0(m) {
  return m < 10 ? '0' + m : m
}
// 给日期拼接上00：00：00 num=1表示开始时间 num=2表示结束时间 默认拼接一天的开始时间
export function concatDate(date, num) {
  return num == undefined ? date + (' 00' + ':', '00:', '00') : date + (' 23' + ':', '59:', '59')
}
export function format(shijianchuo, not) {
  //shijianchuo是整数，否则要parseInt转换
  //not 是否需要时分秒 1 不需要  默认需要
  if (!shijianchuo) {
    return "-";
  }
  var time = new Date(shijianchuo * 1000);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return (
    y +
    "-" +
    add0(m) +
    "-" +
    add0(d) +
    " " +
    (add0(h) +
      ":" +
      add0(mm) +
      ":" +
      "00")

  )
}
export function toTimeStamp(params) {
  params = params.replace(/-/g, '/')
  return new Date(params).getTime() / 1000
}
export function format_y_m(shijianchuo) {
  // shijianchuo是整数，否则要parseInt转换
  if (!shijianchuo) {
    return '-'
  }
  const time = new Date(shijianchuo * 1000)
  const y = time.getFullYear()
  const m = time.getMonth() + 1

  return (
    y +
    ' 年 ' +
    m +
    ' 月'
  )
}

/**
 * @description: 根据某一天获取本月的第一天及最后一天（不传默认为本月第一天）
 * @param {*}  timestamp:  某天时间
 * @Author: zhs
 * @return 毫秒数
 */
export function getMonthFrist(timestamp) {
  const date = timestamp ? new Date(timestamp) : new Date()
  const year = date.getFullYear()
  const month = date.getMonth()
  return new Date(year, month, 1) * 1
}
export function getMonthLast(timestamp) {
  const date = timestamp ? new Date(timestamp) : new Date()
  const year = date.getFullYear()
  const month = date.getMonth()
  // day为0表示获取上一个月最后一天，所以month+1
  // 86300表示一天秒数，最后日期为 23:59:59
  return (new Date(year, month + 1, 0) / 1000 + 86399) * 1000
}
export function getWeekFrist(timestamp) {
  const date = timestamp ? new Date(timestamp) : new Date()
  const week_num = date.getDay() == 0 ? 7 : date.getDay()
  const week_first = new Date(date.setDate(date.getDate() - week_num + 1))
  const year = week_first.getFullYear()
  const mounth = week_first.getMonth()
  const day = week_first.getDate()
  // day为0表示获取上一个月最后一天，所以month+1
  // 86300表示一天秒数，最后日期为 23:59:59
  return new Date(year, mounth, day) * 1
}

export function getWeekLast(timestamp) {
  const date = timestamp ? new Date(timestamp) : new Date()
  const week_num = date.getDay() == 0 ? 7 : date.getDay()
  const week_end = new Date(date.setDate(date.getDate() + (7 - week_num)))
  const year = week_end.getFullYear()
  const mounth = week_end.getMonth()
  const day = week_end.getDate()
  // day为0表示获取上一个月最后一天，所以month+1
  // 86300表示一天秒数，最后日期为 23:59:59
  return (new Date(year, mounth, day) / 1000 + 86399) * 1000
}
export function randomColor() {
  const arrHex = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']
  let strHex = '#'
  let index
  for (let i = 0; i < 6; i++) {
    index = Math.round(Math.random() * 15)
    strHex += arrHex[index]
  }
  return strHex
}

export function getOneArr(arr, childkey = 'children') {
  const data = JSON.parse(JSON.stringify(arr))
  const newData = []
  const callback = (item) => {
    (item[childkey] || (item[childkey] = [])).map((v) => {
      callback(v)
    })
    delete item[childkey]
    newData.push(item)
  }
  data.map((v) => callback(v))
  return newData
}
// let week_second = new Date(date.setDate(date.getDate() + 6))

/**
 * 取出字符串中a标签的跳转链接与内容
 * @param {} richtxt
 * @returns
 */
export function getRichLinks(richtxt) {
  const regex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"[^>]*>(.*?)<\/a>/gi
  const links = [] // 存储匹配结果的数组
  let match // 使用正则表达式进行匹配
  while ((match = regex.exec(richtxt)) !== null) {
    const href = match[1] // 提取href属性
    const text = match[2] // 提取文本内容
    // 可以根据需要提取其他属性

    links.push({
      href,
      text
    })
  }
  return links
}

/**
 * 截取富文本中的video标签
 * @param {*} html
 * @returns
 */
export function getvideoFromRichtext(html) {
  // const regex = /<video.*?src="(.*?)".*?>/g;
  // const html = '<div><p>这是一段富文本，其中包含了source：<source src="example.mp4"></source></p></div>';
  const regex = /<source.*?src=['"](.*?)['"].*?>/g
  const srcList = []
  let match
  while ((match = regex.exec(html)) !== null) {
    srcList.push(match[1])
  }
  // console.log('srcList----->',srcList); // 输出 example.mp4
  return srcList
}

/**
 *
 * @param {*} 树形结构数组
 * @param {*} 要查找的id
 * @returns
 */
export function getTree(arr, id) {
  const pid_s = []
  function get_pid(arr2, id) {
    arr2.forEach((item) => {
      if (item.id == id) {
        pid_s.push(item)

        if (item.pid != 75) {
          get_pid(arr, item.pid)
        }
      } else if (item.children && item.children.length != 0) {
        get_pid(item.children, id)
      }
    })
  }
  // let tree_data = [];
  // console.log("1111====", new Date().getTime());
  get_pid(arr, id)

  return pid_s.reverse()
};

/**
*
* @param {*} 树形结构数组
* @param {*} 要查找的id
* @returns
*/
export function treeById(arr, id) {
  let result = ''
  function get_pid(arr2, id) {
    arr2.forEach((item) => {
      if (item.id == id) {
        result = item
      } else if (item.children && item.children.length != 0) {
        get_pid(item.children, id)
      }
    })
  }
  // let tree_data = [];
  // console.log("1111====", new Date().getTime());
  get_pid(arr, id)

  return result
};

export function de_weight(arr) {
  const map = new Map()
  arr.map((x) => {
    if (!map.has(x.id + x.name)) {
      map.set(x.id + x.name, x)
    }
  })
  return [...map.values()]
};

/**
 * 替换富文本标签
 */
export function replaceHtmlTags(text) {
  if (!text) {
    return false
  }
  const reg = /<[^<>]+>/g// 1、全局匹配g肯定忘记写,2、<>标签中不能包含标签实现过滤HTML标签
  text = text?.replace(/<img.*?>/g, '[图片]')?.replace(reg, '')// 替换HTML标签
  text = text?.replace(/&nbsp;/ig, '')// 替换HTML空格
  return text
};
/**
 * 文件导出
 */
export function createObjectURL(object) {
  return window.URL
    ? window.URL.createObjectURL(object)
    : window.webkitURL.createObjectURL(object)
};
export function exportByXML(obj, url, name, method) {
  const baseURL = process.env.VUE_APP_BASE_URL

  const xhr = new XMLHttpRequest()
  const formData = new FormData()
  const params = toParams(obj)
  xhr.open(method || 'get', baseURL + url + '?' + params) // url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
  xhr.setRequestHeader(
    'Authorization',
    'Bearer ' + localStorage.getItem('token_blk')
  )
  xhr.setRequestHeader('system-type', systemType)
  xhr.responseType = 'blob'
  xhr.getResponse = true;
  ElMessage({
    message: '正在导出中,请稍后...',
    type: 'warning'
  })
  // let loading = ElLoading.service({
  //     text: "加载中...",
  //     background: "rgba(0,0,0,0.7)",
  //     spinner: "el-icon-loading",
  // });
  xhr.onload = function (e) {
    console.log('导出e#####', e)
    // loading.close()
    if (this.status == 200) {
      const blob = this.response
      console.log({ blob })
      // 获取 Content-Disposition 响应头  
      // const contentDisposition = xhr.getResponseHeader('Content-Disposition');
      // if (contentDisposition) {
      //   // 使用正则表达式提取文件名  
      //   const filenameMatch = contentDisposition.match(/filename="([^"]*)"/);
      //   let filename = '';
      //   if (filenameMatch && filenameMatch[1]) {
      //     filename = filenameMatch[1];
      //     console.log({ filename })
      //   } else {
      //     // 如果没有匹配到文件名，可能需要其他逻辑来处理  
      //     console.warn('无法从 Content-Disposition 中提取文件名');
      //   }
      // }

      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob)
      } else {
        const a = document.createElement('a')
        const url = createObjectURL(blob)
        a.href = url
        a.download = name
        document.body.appendChild(a)
        a.click()

        window.URL.revokeObjectURL(url)
        ElMessage({
          message: '导出成功',
          type: 'success'
        })
      }
    }
  }
  xhr.send(formData)
};

export function toParams(param) {
  let result = ''
  for (const name in param) {
    if (typeof param[name] !== 'function') {
      result += '&' + name + '=' + encodeURI(param[name])
    }
  }
  return result.substring(1)
};

export function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]]
  }
  return arr
}



//去除数组中某个元素相同的元素id
export function removeRepeatKeyInArrKey(arr, key) {
  let map = new Map();
  for (let item of arr) {
    if (!map.has(item[key])) {
      map.set(item[key], item);
    }
  }
  return [...map.values()];
}
// 移除数组中的元素
export const removeRepeat = (arr) => {
  let newArr = arr.filter(function (item, index, arr) {
    return arr.indexOf(item) === index;
  });
  return newArr
}
// xlsx导出excel
export function xlsxToExcel(el, tableName) {
  var xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
  var wb = XLSX.utils.table_to_book(document.querySelector(`${el}`), xlsxParam)
  var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
  try {
    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${tableName}.xlsx`)
  } catch (e) {
    if (typeof console !== 'undefined') {
      console.log(e, wbout)
    }
  }
  return wbout
}
export function hasPermission(father_code, child_code) {
  let source = JSON.parse(localStorage.getItem('rotues_blk'))
  // console.log("source->",source)
  let has_auth = false;
  eachTreeData(source, (x) => {
    if (x.code == father_code) {
      if (x.child) {
        x.child.find((x) => {
          if (x.code == child_code) {
            // console.log("相等------,有权限");
            has_auth = true;
          }
        })
      }
    }
  }, 'child')
  return has_auth
}

//遍历树形接口  data是要遍历的树形数组，callback是回调，childKey是树形child的key值
export function eachTreeData(data, callback, childKey) {
  if (!childKey) childKey = "children";
  data.forEach((d) => {
    if (callback(d) !== false && d[childKey])
      eachTreeData(d[childKey], callback, childKey);
  });
}


export function eachTreeDataG(data, callback, childKey = "children") {
  if (!Array.isArray(data)) {
    throw new Error("Data must be an array");
  }

  const stack = [...data];
  while (stack.length > 0) {
    const node = stack.pop();
    const shouldContinue = callback(node);

    if (shouldContinue !== false && node[childKey] && Array.isArray(node[childKey])) {
      stack.push(...node[childKey]);
    }
  }
}

// JS根据数组中所有的属性包括嵌套的属性进行模糊搜索的方法：
export function search_obscure(keyword, arr, one_keys, two_keys) {
  var result = arr.filter(function (item) {
    for (var key in item) {
      if (typeof item[key] === 'object') {
        for (var subKey in item[key]) {
          let index_key = two_keys.findIndex(x => x == subKey);
          if (index_key != -1) {
            // console.log("subLey----", subKey)
            if (String(item[key][subKey]).indexOf(keyword) > -1) {
              return true;
            }
          }
        }
      } else {
        let index_n = one_keys.findIndex(x => x == key);
        if (index_n != -1) {
          // console.log("key--->", key)
          if (String(item[key]).indexOf(keyword) > -1) {
            return true;
          }
        }
      }
    }
    return false;
  });
  return result;
}
export function by_type_get_time(type) {
  let end_day = new Date()
  let start_day;
  switch (type) {
    case "天":
      return [new Date(Date.now() - 86400000), end_day]
    case "月":
      let date_ = new Date()
      start_day = new Date(date_.setMonth(date_.getMonth() - 1))
      return [start_day, end_day]
    case "30天":
      let date_1 = new Date()
      start_day = new Date(date_1.setDate(date_1.getDate() - 30))
      return [start_day, end_day]
    case "周":
      let date2 = new Date()
      start_day = new Date(date2.setDate(date2.getDate() - 7))
      return [start_day, end_day]
    case "年":
      let date3 = new Date()
      start_day = new Date(date3.setFullYear(date3.getFullYear() - 1))
      return [start_day, end_day]
    default:
      break;
  }

}

// 根据key(例如id)找出数组中某元素
export function findElementById(array, key, value) {
  let result = [];
  for (let i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      result.push(array[i]);
    }
  }
  return result;
}

// 递归找出树形结构id对应的元素
export function findTreeElementById(treeArray, id, childKey) {
  for (let i = 0; i < treeArray.length; i++) {
    const element = treeArray[i];
    if (element.id == id) {
      console.log("em--->", element)
      return element;
    }
    if (element[childKey] && element[childKey].length > 0) {
      const foundElement = findTreeElementById(element[childKey], id, childKey);
      if (foundElement) {
        return foundElement;
      }
    }
  }
  return null;
}

// 将中国标准转换为年月日的格式
export function formattedDate(dateStr) {
  const date = new Date(dateStr);
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
}

export function findRootNodeByIdDirect(treeArray, id) {
  // 先找到目标节点
  const targetNode = findTreeElementById(treeArray, id, 'children');
  if (!targetNode) return null; // 如果找不到对应节点，返回 null

  // 调用现有方法查找根节点
  return findRootNodeByNode(treeArray, targetNode);
}

export function findRootNodeByNode(treeArray, node) {
  const indexMap = new Map();
  eachTreeData(treeArray, item => {
    indexMap.set(item.id, item);
  }, 'children');

  // 向上查找根节点
  let current = node;
  while (current) {
    if (current.pid === treeArray[0].pid) {
      return current; // 找到根节点，返回它
    }
    current = indexMap.get(current.pid); // 获取父节点
  }

  return null; // 如果未找到根节点，则返回 null
}

export function markdownToHtml(markdown) {
  markdown = markdown.replace(/^#+ (.*)$/gm, (match, p1) => `<h${match.length - 1}>${p1.trim()}</h${match.length - 1}>`);
  markdown = markdown.replace(/\n\n/g, '</p><p>');
  markdown = `<p>${markdown.trim().replace(/\n/g, '<br>')}</p>`;
  return markdown;
}

// 替换富文本中的图片标签为[图片]
export function replaceImgWithText(html) {
  if (!html) return false
  // 使用正则表达式匹配img标签，并将其替换为[图片]
  return html.replace(/<img[^>]*>/gi, '[图片]');
}


// 获取两天后的时间并跳过节假日
export function getdelaydays(delyday = 2, day = new Date()) {
  let target = day;
  let businessDaysAdded = 0;
  while (businessDaysAdded < delyday) {
    target.setDate(target.getDate() + 1);
    // 检查是否是工作日
    const dayofweek = day.getDay();
    if (dayofweek != 0 && dayofweek != 6) {
      businessDaysAdded++;
    }
  }
  return format(target.getTime() / 1000)
}

//已知url下载到本地
export function downloadUrl(url, name = '报价') {
  console.log({ url ,name})
  if (!url) {
    return false
  }
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank"; 
  a.download = name;
  document.body.appendChild(a);
  a.click();
}

// 进一法保留n位小数
export function roundUp(num, n = 2) {
  let factor = Math.pow(10, n);
  return Math.ceil(num * factor) / factor;
}


// 校验输入的数字是一个合法有效的数字
export function setValue(e) {
  return e.replace(/[^0-9.]/g, "") // 移除非法字符  
    .replace(/^0+/, "0")
    .replace(/^0+(\d+|\.$)/, "0$1") // 只保留一个开头的零（如果存在），并处理以零开头且后面可能跟着点的情况  
    .replace(/\.{2,}/g, ".")// 确保只有一个小数点（虽然在这个逻辑下可能是多余的，因为前面的处理已经避免了多个点）  
    .replace(/\./g, function (match, index, string) {
      return index === string.indexOf(".") ? "." : "";
    }).replace(/^0+(?=\d)/, "")
    || ""; // 如果结果为空字符串，则返回"0"  
}


export function formatNumber(value) {
  // 允许空字符串
  if (value === '') return value;

  // 移除所有非数字和负号、小数点的字符
  value = value.replace(/[^\d.-]/g, '');

  // 只允许一个负号，且必须在开头
  if (/-/.test(value) && !/^-/.test(value)) {
    value = value.replace(/-/g, '');
  }
  if (value.startsWith('-') && value.length > 1) {
    value = '-' + value.substring(1).replace(/-/g, '');

    value = '-' + value.substring(1).replace(/^0+(?=\d)/, "");
  }
  if (value.startsWith('.')) {
    value = ''
  }
  value = value.replace(/^0+/, "0")
    .replace(/^0+(\d+|\.$)/, "0$1") // 只保留一个开头的零（如果存在），并处理以零开头且后面可能跟着点的情况  
    .replace(/\.{2,}/g, ".")// 确保只有一个小数点（虽然在这个逻辑下可能是多余的，因为前面的处理已经避免了多个点）  
    .replace(/\./g, function (match, index, string) {
      return index === string.indexOf(".") ? "." : "";
    }).replace(/^0+(?=\d)/, "")
    || ""; // 如果结果为空字符串，则返回"0"  

  return value;
}

export function getNowFormat() {
  let date = new Date();
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
  return Y + M + D
}

export function getDayOfWeek(date) {
  // 如果传入的是日期字符串，则先将其转换为 Date 对象
  if (typeof date === 'string') {
    date = new Date(date);
  }
  // 获取星期几（0 表示星期日，1 表示星期一，以此类推，6 表示星期六）
  const dayOfWeek = date.getDay();

  // 创建一个数组，将数字映射到星期几的名称
  const daysOfWeek = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

  // 返回星期几的名称
  return daysOfWeek[dayOfWeek];
}


export function byIdGetItem(target_list, id, label, childkey = "children") {
  let yiwei_arr = getOneArr(target_list, childkey);
  let findItem = yiwei_arr.find((x) => x.id == id);
  if (findItem) {
    return {
      id: findItem?.id,
      value: findItem[label],
    };
  } else {
    return {
      id: "",
      value: "",
    };
  }
}
export function byNameGetItem(target_list, name, label, childkey = "children") {
  let yiwei_arr = getOneArr(target_list, childkey);
  let findItem = yiwei_arr.find((x) => x[label] == name);

  if (findItem) {
    return {
      id: findItem?.id,
      value: findItem[label],
    };
  } else {
    return {
      id: "",
      value: "",
    };
  }
}

//arr是需要查询的树形结构，searchCon是需要查询的关键词，keyvalues是查询数组中需要匹配的value的key值/键值，是一个数组，可以传多个
export function matchTreeData(arr, searchCon, keyvalues, childKey) {
  if (!childKey) childKey = "children";
  let newArr = [];
  arr.forEach((item) => {
    for (let i = 0, len = keyvalues.length; i < len; i++) {
      let nameKey = keyvalues[i];
      if (item.hasOwnProperty(nameKey)) {
        if (item[nameKey] && item[nameKey].indexOf(searchCon) !== -1) {
          newArr.push(item);
          break;
        } else {
          if (item[childKey] && item[childKey].length > 0) {
            let resultArr = matchTreeData(item[childKey], searchCon, keyvalues, childKey);
            if (resultArr && resultArr.length > 0) {
              newArr.push({
                ...item,
                [childKey]: resultArr,
              });
              break;
            }
          }
        }
      } else {
        continue;
      }
    }
  });
  return newArr;
}


// 给树形结构数据添加层级 array是需要添加层级的树形结构数据，level是需要添加树形结构的层级 
export function arrayFlaglevel(array, level, childKey) {
  if (!array || !array.length) return
  if (!childKey) childKey = "children";
  array.forEach(item => {
    item.level = level
    if (item[childKey] && item[childKey].length) {
      arrayFlaglevel(item[childKey], level + 1, childKey)
    }
  })
}

// 找出树形结构中某个元素的所有父级并更新属性
export function setDataById(data, id, property, value, childKey) {
  if (!childKey) childKey = "children";
  for (let i = 0; i < data.length; i++) {
    if (data[i].id === id) {
      data[i][property] = value;
      break;
    } else if (data[i][childKey] && data[i][childKey].length > 0) {
      setDataById(data[i][childKey], id, property, value, childKey);
    }
  }
}

// 找出指定id对应数据所有的父级元素
export function findParentElements(tree, targetId, childKey, parents = []) {
  if (!childKey) childKey = "children";
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.id === targetId) {
      return parents;
    }
    if (node[childKey]) {
      const found = findParentElements(node[childKey], targetId, childKey, [...parents, node]);
      if (found) {
        return found;
      }
    }
  }
  return null;
}


//数组中随机取一个值
export function randomColorG(arr) {
  var element = arr[Math.floor((Math.random() * arr.length))];
  return element;
}

export function intToChinese(n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
    return "数据非法";
  let unit = "千百拾亿千百拾万千百拾元角分",
    str = "";
  n += "00";
  let p = n.indexOf('.');
  if (p >= 0) {
    n = n.substring(0, p) + n.substr(p + 1, 2);
    unit = unit.substr(unit.length - n.length);
  }

  for (var i = 0; i < n.length; i++)
    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
  return str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g,
    "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
}


// 实现假发乘除运算，确保不丢失精度  op运算类型1（add,sub,mul,divide）
export function operation(a, b, op) {
  a = Number(a);
  b = Number(b);
  var o1 = toInt(a);
  var o2 = toInt(b);
  var n1 = o1.num;
  var n2 = o2.num;
  var t1 = o1.times;
  var t2 = o2.times;
  var max = t1 > t2 ? t1 : t2;
  var result = null;
  switch (op) {
    case 'add':
      if (t1 === t2) {
        result = n1 + n2
      } else if (t1 > t2) {
        result = n1 + n2 * (t1 / t2)
      } else {
        result = n1 * (t2 / t1) + n2
      }
      return result / max;
    case 'sub':
      if (t1 === t2) {
        result = n1 - n2
      } else if (t1 > t2) {
        result = n1 - n2 * (t1 / t2)
      } else {
        result = n1 * (t2 / t1) - n2
      }
      return result / max;
    case 'mul':
      result = (n1 * n2) / (t1 * t2)
      return result
    case 'divide':
      result = (n1 / n2) * (t2 / t1)
      return result
  }
}

export function phone_reg(num) {
  // let num_reg = /^(\+?0?86\-?)?1[345789]\d{9}$/
  // var phones = {
  //   'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  //   'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  //   'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  //   'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
  //   'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  //   'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
  //   'da-DK': /^(\+?45)?(\d{8})$/,
  //   'el-GR': /^(\+?30)?(69\d{8})$/,
  //   'en-AU': /^(\+?61|0)4\d{8}$/,
  //   'en-GB': /^(\+?44|0)7\d{9}$/,
  //   'en-HK': /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/,
  //   'en-IN': /^(\+?91|0)?[789]\d{9}$/,
  //   'en-NZ': /^(\+?64|0)2\d{7,9}$/,
  //   'en-ZA': /^(\+?27|0)\d{9}$/,
  //   'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  //   'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
  //   'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5)?|50)\s?(\d\s?){4,8}\d$/,
  //   'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  //   'he-IL': /^(\+972|0)([23489]|5[0248]|77)[1-9]\d{6}/,
  //   'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
  //   'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  //   'ja-JP': /^(\+?81|0)\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/,
  //   'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  //   'nb-NO': /^(\+?47)?[49]\d{7}$/,
  //   'nl-BE': /^(\+?32|0)4?\d{8}$/,
  //   'nn-NO': /^(\+?47)?[49]\d{7}$/,
  //   'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  //   'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
  //   'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  //   'ru-RU': /^(\+?7|8)?9\d{9}$/,
  //   'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  //   'tr-TR': /^(\+?90|0)?5\d{9}$/,
  //   'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
  //   'zh-CN': /^(\+?0?86\-?)?1[345789]\d{9}$/,
  //   'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
  // };
  // for (var p in phones) {
  //   if (phones[p].test(num)) {
  //     return true;
  //   }
  // }
  // return false;

  const internationalPhoneRegex = /^(\+?\d{1,4})?\d{7,15}$/;
  const chinaPhoneRegex = /^(\+?86)?1[3-9]\d{9}$/;
  // 检查是否符合通用国际手机号规则
  if (internationalPhoneRegex.test(num)) {
    if (num.startsWith("+86") || num.startsWith("86")) {
      return chinaPhoneRegex.test(num);
    }
    // 其他国家的手机号直接返回 true
    return true;
  }
  return false
}
export function byNameGetId(target_list, name) {
  console.log("打印target_list", target_list);
  let yiwei_arr = getOneArr(target_list);
  let select_arr = yiwei_arr.filter((x) => {
    return x.name.search(name) != -1;
  });
  return select_arr;
}

export function getYearList(startYear = 2020, currentYear = new Date().getFullYear()) {
  const yearList = [];
  for (let i = startYear; i <= currentYear; i++) {
      yearList.push(i);
  }
  return yearList;
};
export function getNowFormatJQ() {
	let date = new Date();
	let Y = date.getFullYear() + '-'
	let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
	let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
	let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
	let Mi = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
	let S = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
	return Y + M + D + H + Mi + S
}